import React, { useEffect, useState } from "react";
import {
  Button,
  Input,
  Modal,
  Space,
  Table,
  Form,
  Flex,
  TablePaginationConfig,
} from "antd";
import instance from "../../axios/axios-instance";
import { setSuccessMessage } from "../../redux/actions/AppMessageActions";
import { AnyAction } from "redux";
import { ThunkDispatch } from "redux-thunk";
import { useDispatch } from "react-redux";

type AppDispatch = ThunkDispatch<any, unknown, AnyAction>;

interface SchemeStatus {
  id: number;
  name: string;
}

function SchemeStatusTable() {
  const [data, setData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [isCreateModalOpen, setCreateModalOpen] = useState(false);
  const [isEditModalOpen, setEditModalOpen] = useState(false);
  const [editSchemeStatusForm] = Form.useForm();
  const [selectedSchemeStatus, setSelectedSchemeStatus] =
    useState<SchemeStatus>();
  const [query, setQuery] = useState("");
  const dispatch = useDispatch<AppDispatch>();

  const fetchSchemeStatuses = async () => {
    const response = await instance.get("/api/administration/scheme-status");
    setData(response?.data);
    setFilteredData(response?.data);
  };
  useEffect(() => {
    fetchSchemeStatuses();
  }, []);

  const performSearch = () => {
    const filteredData = data.filter((schemeStatus: SchemeStatus) =>
      schemeStatus.name.toLowerCase().includes(query.toLowerCase())
    );
    setFilteredData(filteredData);
  };

  const resetSearch = () => {
    setQuery("");
    setFilteredData(data);
  };

  const createNewSchemeStatus = async () => {
    const response = await instance.post("/api/administration/scheme-status", {
      ...editSchemeStatusForm.getFieldsValue(),
    });
    if (response?.status >= 200 && response?.status < 300) {
      dispatch(setSuccessMessage("Scheme Status added"));
      fetchSchemeStatuses();
    }
    setCreateModalOpen(false);
  };

  const editSchemeStatus = async () => {
    const response = await instance.put(
      `/api/administration/scheme-status?id=${selectedSchemeStatus?.id}`,
      {
        ...editSchemeStatusForm.getFieldsValue(),
      }
    );
    if (response?.status >= 200 && response?.status < 300) {
      dispatch(setSuccessMessage("Scheme Status Updated"));
      fetchSchemeStatuses();
    }
    setEditModalOpen(false);
  };

  const handleDetails = (record: any) => {
    editSchemeStatusForm.setFieldsValue({
      scheme_status: record.scheme_status,
    });
    setSelectedSchemeStatus(record);
    setEditModalOpen(true);
  };

  function FormIsValid() {
    const data = editSchemeStatusForm.getFieldsValue();
    return data.name;
  }

  const columns: any[] = [
    {
      title: "Scheme Status",
      dataIndex: "scheme_status",
      key: "scheme_status",
      width: 150,
      editable: true,
      fixed: "left",
    },
    {
      title: "Actions",
      key: "actions",
      width: 150,
      render: (record: any) => (
        <Space size="small" style={{ minWidth: "112px" }}>
          <Button onClick={() => handleDetails(record)}>Details</Button>
        </Space>
      ),
    },
  ];

  const [currentPage, setCurrentPage] = useState(1);
  const [page_size, setPage_size] = useState(4);
  const [windowHeight, setWindowHeight] = useState(window.innerHeight);

  useEffect(() => {
    let timeoutId: any;

    // Define a function to update the window height with a delay
    const updateWindowHeight = () => {
      timeoutId = setTimeout(() => {
        setWindowHeight(window.innerHeight);
      }, 300);
    };

    // Attach the event listener when the component mounts
    window.addEventListener("resize", updateWindowHeight);

    // Remove the event listener and clear the timeout when the component unmounts
    return () => {
      window.removeEventListener("resize", updateWindowHeight);
      clearTimeout(timeoutId); // Clear any pending timeouts
    };
  }, []);

  console.log("schemeStatus form", editSchemeStatusForm.getFieldsValue());

  return (
    <Space direction="vertical">
      <Flex justify="space-between">
        <Space>
          <Input
            value={query}
            onChange={(e) => setQuery(e.target.value.trim())}
            placeholder="Enter search to begin"
          ></Input>
          <Button disabled={!query} onClick={() => performSearch()}>
            Search
          </Button>
          <Button
            disabled={!query.trim() || filteredData?.length === 0}
            onClick={() => resetSearch()}
          >
            Reset
          </Button>
        </Space>
        <Space align="end" direction="horizontal">
          <Button
            type="primary"
            onClick={() => {
              editSchemeStatusForm.resetFields();
              setCreateModalOpen(true);
            }}
          >
            Add Scheme Status
          </Button>
        </Space>
      </Flex>
      <Table
        dataSource={filteredData}
        columns={columns}
        rowKey="id"
        scroll={{ y: windowHeight - 420 }}
        style={{ width: 650 }}
        onChange={(config: TablePaginationConfig) => {
          setPage_size(config.pageSize!);
          setCurrentPage(config.current!);
        }}
        pagination={{
          total: filteredData?.length,
          showTotal: (total) => `${total} rows`,
          pageSize: page_size,
          current: currentPage,
        }}
      />
      <Modal
        title="Create a Scheme Status"
        open={isCreateModalOpen}
        onOk={createNewSchemeStatus}
        okText="Save"
        /* okButtonProps={{ disabled: !FormIsValid() }} */
        onCancel={() => {
          setCreateModalOpen(false);
        }}
      >
        <Form layout="vertical" form={editSchemeStatusForm}>
          <Form.Item label="Scheme Status" name="scheme_status">
            <Input />
          </Form.Item>
        </Form>
      </Modal>
      <Modal
        title="Edit Scheme Status"
        open={isEditModalOpen}
        onOk={editSchemeStatus}
        okText="Update"
        /* okButtonProps={{ disabled: !FormIsValid() }} */
        onCancel={() => {
          setEditModalOpen(false);
        }}
      >
        <Form layout="vertical" form={editSchemeStatusForm}>
          <Form.Item label="Scheme Status" name="scheme_status">
            <Input />
          </Form.Item>
        </Form>
      </Modal>
    </Space>
  );
}

export default SchemeStatusTable;
